// extracted by mini-css-extract-plugin
module.exports = {"Registration":"Registration_Registration__2zljd","Open":"Registration_Open__3E9ly","Close":"Registration_Close__1N-bC"};